import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className='py-5 border-t border-gray-300 flex items-center justify-center'>
      <p className='font-semibold'> تم التطوير بواسطة
        <Link href="https://wa.me/+201552242010"
          target="_blank" className='mx-1 font-bold text-orange-400'>عمر عثمان</Link>
      </p>


    </footer>
  );
}

export default Footer;
